

const ValidationError = require('../error/ValidationError').default;

module.exports = (error) => {
  console.error(error);

  if (error.name === 'InvalidEntry') {
    throw new ValidationError('Validation error while processing Contentful request.');
  }

  throw new Error('Unknown error while processing Contentful request');
};

